import { pageData } from '@/util/page_data'

// Our self-hosted Plausible server, shared by every theme. The theme's own site on it is the `domain` PageData
// carries, not this host.
const SCRIPT_URL = 'https://analytics.lucaregnskap.no/js/script.pageview-props.tagged-events.js'

// Read per event because Turbo replaces the PageData blob on every visit.
function customProps(): Record<string, string> {
  return { logged_in: String(pageData().user.email !== undefined), site: 'application' }
}

export function startPlausible() {
  const { plausible } = pageData()
  if (!plausible) return

  // Queues calls until the vendor script loads and replays `q`.
  if (!window.plausible) {
    const queue: IArguments[] = []
    window.plausible = Object.assign(
      function () {
        queue.push(arguments)
      },
      { q: queue },
    )
  }

  // The vendor script reads its site and the props for the pageview it counts itself off its own tag.
  const script = document.createElement('script')
  script.src = SCRIPT_URL
  script.dataset.domain = plausible.domain
  for (const [name, value] of Object.entries(customProps())) script.setAttribute(`event-${name}`, value)
  document.head.append(script)

  // Plausible only counts full page loads, so a Turbo visit reports its own pageview.
  document.addEventListener('turbo:visit', () => {
    window.plausible?.('pageview', { props: customProps() })
  })
}

export function firePlausibleGoal(goalName: string, props: Record<string, string> = {}) {
  window.plausible?.(goalName, { props: { ...customProps(), ...props } })
}
